const validatePidFile = function (pidFile, onValidate) {
  const reader = new FileReader()
  let isValid = true
  reader.onload = e => {
    let rows = e.target.result.split('\n')
    for (let r in rows) {
      if (parseInt(r) === 0) continue
      if (rows[r] === '') {
        continue
      }
      let household_id = rows[r].split(',')[0]
      let respondents = rows[r].split(',')[1]
      let effective_date = rows[r].split(',')[2]
      if (household_id === undefined || respondents === undefined || effective_date === undefined ||
        isNaN(household_id) || isNaN(respondents) || isNaN(Date.parse(effective_date))) {
        isValid = false
        break
      }
    }
    onValidate(isValid)
  }
  reader.readAsText(pidFile)
}

export {
  validatePidFile
}



// WEBPACK FOOTER //
// ./src/app/appLogic/targets/pid/PidLogic.js